import axios, { AxiosResponse } from 'axios';
import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '@app/constants/queryKeys';
import { useConfig } from '@app/config';
import { ApplicationConfig } from '@app/config/types';

type ActivePoolsResponse = {
  id: string;
}[];

async function fetcher(config: ApplicationConfig | undefined) {
  try {
    const { data } = await axios.get<void, AxiosResponse<ActivePoolsResponse>>(
      `${config?.URLS.middlewareUrl}/kim-master/active-pools`
    );

    return data.reduce<Record<string, boolean>>((r, item) => {
      r[item.id.toLowerCase()] = true;

      return r;
    }, {});
  } catch (e) {
    console.error(e);

    return;
  }
}

export function useVaultsActivePools() {
  const config = useConfig();

  return useQuery<Record<string, boolean> | undefined>(
    [QueryKeys.VAULTS_ACTIVE_POOLS],
    () => fetcher(config),
    {
      staleTime: 5000,
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      retry: 0,
      enabled: !!config?.URLS.middlewareUrl
    }
  );
}
